import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { WorkspaceLayoutService } from '../../services/workspace-layout.service';

export type WorkspaceView = 'compact' | 'full';

/** Selects page-owned content; data components know nothing about window modes. */
@Directive({ selector: '[workspaceView]', standalone: true })
export class WorkspaceViewDirective implements OnDestroy {
  private view: WorkspaceView = 'full';
  private rendered = false;
  private queued = false;
  private destroyed = false;
  private readonly subscription: Subscription;

  constructor(
    private readonly template: TemplateRef<unknown>,
    private readonly container: ViewContainerRef,
    private readonly layout: WorkspaceLayoutService,
  ) {
    this.subscription = layout.modeChanged$.subscribe(() => this.scheduleRender());
  }

  @Input() set workspaceView(view: WorkspaceView) {
    this.view = view;
    this.render();
  }

  private scheduleRender(): void {
    if (this.queued) return;
    this.queued = true;
    // Route activation can publish while a parent view is being checked.
    Promise.resolve().then(() => {
      this.queued = false;
      if (!this.destroyed) this.render();
    });
  }

  private render(): void {
    const show = this.view === (this.layout.dockedRight ? 'compact' : 'full');
    if (show === this.rendered) return;
    this.rendered = show;
    if (show) this.container.createEmbeddedView(this.template);
    else this.container.clear();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.subscription.unsubscribe();
  }
}
